export enum PwaInstallation {
  promptLater = 0,
  promptToInstall = 1,
  promptDisabled = 2
}
